import { createFileRoute } from '@tanstack/react-router';

import { FilteredProfilesPage } from '@/features/(insight)/filtered-profiles/index';

export const Route = createFileRoute('/workspace/$workspaceId/insight/filtered-profiles')({
  component: FilteredProfilesPage,
});
